interface RuntimeConfig {
  VUE_APP_API_URL?: string;
  VUE_APP_PLATFORM_UUID?: string;
  VUE_APP_PLATFORM_KEY?: string;
  VUE_APP_NAME_APP?: string;
  VUE_APP_CONTACT_EMAIL?: string;
  VUE_APP_TARTEAUCITRON_URI?: string;
  VUE_APP_MAPBOX_TOKEN?: string;
  VUE_APP_IREBY_EOI?: string;
  VUE_APP_IREBY_EOI_USER?: string;
  VUE_APP_IREBY_EOI_PASWORD?: string;
  VUE_APP_MATOMO_URL?: string;
  VUE_APP_MATOMO_ID?: string;
  VUE_APP_RECAPTCHA_SITE_KEY?: string;
  VUE_APP_FEDERATE_LINK?: string;
  VUE_APP_SSO_CLIENT_SECRET?: string;
  VUE_APP_SSO_PARTNER_CLIENT_ID?: string;
  VUE_APP_SSO_PARTNER_PATH?: string;
  VUE_APP_IREBY_URL?: string;
  VUE_APP_MERCHANT_URL?: string;
  VUE_APP_SERVICE_DESK_ID?: string;
  VUE_APP_SERVICE_DESK_REQUEST_ID?: string;
  VUE_APP_MAINTENANCE?: string;
  VUE_APP_VERSION?: string;
}

declare global {
  interface Window {
    __CONFIG__?: RuntimeConfig;
  }
}

// window.__CONFIG__ comes from /config.js, loaded by index.html before this bundle.
// On K8s an exact-match nginx location serves the per-platform file from the mounted
// ConfigMap; everywhere else the app falls back to the build-time process.env.VUE_APP_*
// values, so `npm run serve` and the Clever builds keep working unchanged.
//
// public/config.js is the no-op that makes /config.js resolve where nothing injects it.
// Do not delete it: index.html requests /config.js unconditionally, and without the file
// the SPA fallback answers with index.html, which the browser then parses as JavaScript.
// Keep it to the single assignment - it is publicly served on every customer domain, so
// it must carry no configuration values and no description of our infrastructure.
// eslint-disable-next-line no-underscore-dangle
const w: RuntimeConfig = window.__CONFIG__ || {};

const config = {
  apiUrl: w.VUE_APP_API_URL || process.env.VUE_APP_API_URL || '',
  platformUuid: w.VUE_APP_PLATFORM_UUID || process.env.VUE_APP_PLATFORM_UUID || '',
  platformKey: w.VUE_APP_PLATFORM_KEY || process.env.VUE_APP_PLATFORM_KEY || '',
  nameApp: w.VUE_APP_NAME_APP || process.env.VUE_APP_NAME_APP || '',
  contactEmail: w.VUE_APP_CONTACT_EMAIL || process.env.VUE_APP_CONTACT_EMAIL || '',
  tarteaucitronUri: w.VUE_APP_TARTEAUCITRON_URI || process.env.VUE_APP_TARTEAUCITRON_URI || '',
  mapboxToken: w.VUE_APP_MAPBOX_TOKEN || process.env.VUE_APP_MAPBOX_TOKEN || '',
  irebyEoi: w.VUE_APP_IREBY_EOI || process.env.VUE_APP_IREBY_EOI || '',
  irebyEoiUser: w.VUE_APP_IREBY_EOI_USER || process.env.VUE_APP_IREBY_EOI_USER || '',
  irebyEoiPasword: w.VUE_APP_IREBY_EOI_PASWORD || process.env.VUE_APP_IREBY_EOI_PASWORD || '',
  matomoUrl: w.VUE_APP_MATOMO_URL || process.env.VUE_APP_MATOMO_URL || '',
  matomoId: w.VUE_APP_MATOMO_ID || process.env.VUE_APP_MATOMO_ID || '',
  recaptchaSiteKey: w.VUE_APP_RECAPTCHA_SITE_KEY || process.env.VUE_APP_RECAPTCHA_SITE_KEY || '',
  federateLink: w.VUE_APP_FEDERATE_LINK || process.env.VUE_APP_FEDERATE_LINK || '',
  ssoClientSecret: w.VUE_APP_SSO_CLIENT_SECRET || process.env.VUE_APP_SSO_CLIENT_SECRET || '',
  ssoPartnerClientId: w.VUE_APP_SSO_PARTNER_CLIENT_ID || process.env.VUE_APP_SSO_PARTNER_CLIENT_ID || '',
  ssoPartnerPath: w.VUE_APP_SSO_PARTNER_PATH || process.env.VUE_APP_SSO_PARTNER_PATH || '',
  irebyUrl: w.VUE_APP_IREBY_URL || process.env.VUE_APP_IREBY_URL || '',
  merchantUrl: w.VUE_APP_MERCHANT_URL || process.env.VUE_APP_MERCHANT_URL || '',
  serviceDeskId: w.VUE_APP_SERVICE_DESK_ID || process.env.VUE_APP_SERVICE_DESK_ID || '',
  serviceDeskRequestId: w.VUE_APP_SERVICE_DESK_REQUEST_ID || process.env.VUE_APP_SERVICE_DESK_REQUEST_ID || '',
  maintenance: (w.VUE_APP_MAINTENANCE || process.env.VUE_APP_MAINTENANCE || '') === 'true',
  version: w.VUE_APP_VERSION || process.env.VUE_APP_VERSION || '',
};

export default config;
